<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-3 lg:py-3 px-6 flex align-items-center justify-content-between lg:static">
            <img src="images/blocks/logos/kitrin-logo-black-revised-software-rev2.png" alt="IsoEvolve" height="50"
                 class="mr-0 lg:mr-6">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 mr-5 p-ripple"
                   v-styleclass="{ selector: '#navbar-sub-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-ellipsis-v text-2xl"></i>
                </a>
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-7', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
            <div id="navbar-sub-7"
                 class="hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none">
                <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
                    <li>
                        <a @click="processConfiguration" v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-cog text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Configuration</span>
                        </a>
                    </li>
                    <li>
                        <a @click="processProfile" v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-id-card text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Profile</span>
                        </a>
                    </li>
                    <li>
                        <a v-ripple
                           class="flex px-6 p-3 lg:px-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0" v-badge.danger></i>
                            <span class="block lg:hidden font-medium">Notifications</span>
                        </a>
                    </li>
                    <li>
                        <a @click="processLogout" v-tooltip="'Logout'" v-ripple
                           class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                            <i class="pi pi-power-off text-base lg:text-2xl mr-2 lg:mr-0"></i>
                            <span class="block lg:hidden font-medium">Logout</span>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
        <div id="navbar-7"
             class="py-3 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 border-top-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <li>
                    <a @click="processOverview" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Overview</span>
                    </a>
                </li>
                <li>
                    <a @click="processApplications" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-shopping-cart mr-2"></i>
                        <span>Applications</span>
                    </a>
                </li>

            </ul>
        </div>
    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[MenuUserModuleMain][mounted] System is active.");
                console.log("[MenuUserModuleMain][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[MenuUserModuleMain][mounted] System is NOT active.");
                console.log("[MenuUserModuleMain][mounted] Error = ", e);

                this.userStore.clearUser;
                this.$router.push("login");
            });

        if (this.userStore.user === undefined) {
            console.log("[MenuUserModuleMain][mounted] User is NOT defined.");

            this.userStore.clearUser;
            this.$router.push('login');
        } else {
            console.log("[MenuUserModuleMain][mounted] User is defined. this.userStore.user.id = ", this.userStore.user.id);

            UserService.getUser(this.userStore.user.id)
                .then(data => {
                    this.profile = data.data;
                    console.log("[MenuUserModuleMain][mounted] Data = ", data);

                })
                .catch(e => {
                    console.log("[MenuUserModuleMain][mounted] No user data found.");
                    console.log("[MenuUserModuleMain][mounted] Error = ", e);

                    this.userStore.clearUser;
                    this.$router.push('login');
                });
        }
    },
    data() {
        return {
            profile: {},
        }
    },
    methods: {
        processLogout() {
            console.log("[MenuUserModuleMain][processLogout] Beginning.");

            this.userStore.$reset();
            this.userStore.clearUser;
            window.location.href = "/#/login";
            window.location.reload();
        },
        processProfile() {
            console.log("[MenuUserModuleMain][processProfile] Beginning.");
            window.location.href = "/#/commonProfile";
        },
        processConfiguration() {
            console.log("[MenuUserModuleMain][processConfiguration] Beginning.");
            window.location.href = "/#/commonConfigurationBasic";
        },
        processApplications() {
            console.log("[MenuUserModuleMain][processApplications] Beginning.");
            window.location.href = "/#/healthApplications";
        },
        processOverview() {
            console.log("[MenuUserModuleMain][processOverview] Beginning.");
            window.location.href = "/#/userOverview";
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
